export default __webpack_public_path__ + "static/media/LinkedInIcon.d2cfd58c.svg";